import styled from '@emotion/styled';
import { Button, colors, Stack, Typography } from '@ui-components/neo.tax';

export const StyledApprovalStatusContainer = styled(Stack)({
  padding: '16px',
  borderRadius: '8px',
  backgroundColor: colors.green[50],
  border: `1px solid ${colors.green[200]}`,
  marginBottom: '16px',
});

export const StyledApprovalStatusText = styled(Typography)({
  color: colors.green[700],
});

export const StyledPartialApprovalContainer = styled(Stack)({
  padding: '8px 12px',
  borderRadius: '6px',
  backgroundColor: colors.green[50],
  border: `1px solid ${colors.green[200]}`,
  marginBottom: '16px',
});

export const StyledPartialApprovalText = styled(Typography)({
  color: colors.green[700],
});

export const StyledBlockingMessage = styled(Stack)({
  padding: '16px',
  borderRadius: '8px',
  backgroundColor: colors.orange[50],
  border: `1px solid ${colors.orange[200]}`,
});

export const StyledButton = styled(Button)({
  margin: 0,
});
